// extracted by mini-css-extract-plugin
export default {"sortInfo":"sortInfo__ZDE2Y","sortInfoTooltip":"sortInfoTooltip__Zjc2Y"};